function argsort(array) {
  const arrayObject = array.map((value, idx) => { return { value, idx }; });
  arrayObject.sort((a, b) => {
      if (a.value > b.value) {
          return -1;
      }
      if (a.value < b.value) {
          return 1;
      }
      return 0;
  });
  const argIndices = arrayObject.map(data => data.idx);
  return argIndices;
}

export default function extract_on_time_bins(data_, start, end, bins, binwidth) {
  // console.log(data_.length, start, end);
  // console.log(data_)
  data_ = data_.slice(start, end)
  const data = [];
  while (data_.length) data.push(data_.splice(0, binwidth))
  let sp = []
  for (let i = 0; i < bins; i++) {
    let mean = 0.0
    for (let j = 0; j < binwidth; j++) {
      mean += data[i][j] ** 2
    }
    mean = mean / binwidth
    sp.push(Math.sqrt(mean))
  }
  let arg_sp = argsort(sp)
  let new_data = []
  for (let i = 0; i < bins; i++) {
    new_data.push(data[arg_sp[i]])
  }
  return new_data
}